import React, { ComponentProps, Fragment } from 'react';

export const BottomSheetCircularPagerWrapper = (props: ComponentProps<typeof Fragment>) => <Fragment {...props} />;
export const CircularPagerSheetHandleGestureWrapper = (props: ComponentProps<typeof Fragment>) => (
    <Fragment {...props} />
);
